import { apiClient } from './axios';

import type {
  EmailConnector,
  CreateEmailConnectorDto,
  UpdateEmailConnectorDto,
} from '@repo/shared-types';

export const emailConnectorsApi = {
  list: async (): Promise<EmailConnector[]> => {
    const response = await apiClient.get<EmailConnector[]>('/email-connectors');
    return response.data;
  },

  create: async (dto: CreateEmailConnectorDto): Promise<EmailConnector> => {
    const response = await apiClient.post<EmailConnector>('/email-connectors', dto);
    return response.data;
  },

  update: async (id: string, dto: UpdateEmailConnectorDto): Promise<EmailConnector> => {
    const response = await apiClient.patch<EmailConnector>(`/email-connectors/${id}`, dto);
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/email-connectors/${id}`);
  },

  test: async (id: string): Promise<{ success: boolean; error?: string }> => {
    const response = await apiClient.post<{ success: boolean; error?: string }>(
      `/email-connectors/${id}/test`,
    );
    return response.data;
  },
};
